import { IStep } from '../../data/api/models';

const lsb: IStep[] = [
  {
    title: 'Trip Details',
    key: 'tripDetails',
    route: '/trip-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: false,
  },
  {
    title: 'Cover Choice',
    key: 'schemeChoice',
    route: '/scheme-choice',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: true,
  },
  {
    title: 'Cover Options',
    key: 'additionalCover',
    route: '/additional-cover',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Medical',
    key: 'medicalDeclaration',
    route: '/medical-declaration',
    calculatePremium: false,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Personal Details',
    key: 'personalDetails',
    route: '/personal-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Payment',
    key: 'payment',
    route: '/payment',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Complete',
    key: 'complete',
    route: '/complete',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    hidden: true,
  },
];

const newFlow: IStep[] = [
  {
    title: 'Your Cover Details',
    key: 'tripDetails',
    route: '/trip-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: false,
  },
  {
    title: 'Your Health',
    key: 'declaration',
    route: '/declaration',
    calculatePremium: false,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Your Quote',
    key: 'schemeChoice',
    route: '/scheme-choice',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: true,
  },
  {
    title: 'Your Confirmation',
    key: 'personalDetails',
    route: '/personal-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Your Payment',
    key: 'payment',
    route: '/payment',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Complete',
    key: 'complete',
    route: '/complete',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    hidden: true,
  },
];

const over40Renewal: IStep[] = [
  {
    title: 'Payment',
    key: 'payment',
    route: '/payment',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Complete',
    key: 'complete',
    route: '/complete',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    hidden: true,
  },
];

const eurp: IStep[] = [
  {
    title: 'Trip Details',
    key: 'tripDetails',
    route: '/trip-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: false,
  },
  {
    title: 'Cover Choice',
    key: 'schemeChoice',
    route: '/scheme-choice',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    clearAdditionalCoverOptions: true,
  },
  {
    title: 'Cover Options',
    key: 'additionalCover',
    route: '/additional-cover',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Personal Details',
    key: 'personalDetails',
    route: '/personal-details',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Payment',
    key: 'payment',
    route: '/payment',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
  },
  {
    title: 'Complete',
    key: 'complete',
    route: '/complete',
    calculatePremium: true,
    saveApplication: true,
    saveApplicationWithPatch: false,
    hidden: true,
  },
];

export const stepsCustom = {
  'lsb-b2c': lsb,
  'eurp-b2c': eurp,
  'over-40-renewal': over40Renewal,
  'csis-b2c': newFlow,
  'tpl-b2c': newFlow,
  'camc-b2c': newFlow,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/stepsCustom.tsx